import React from 'react';
import RegisterUser from './RegisterUser';
import DeleteUser from "./DeleteUser";
import ResetAnswers from "./ResetAnswers";
import ManageTeams from "./teams/ManageTeams";
import { Modal } from 'react-bootstrap';
import './ManageDialogView.css';
import {PollFreezeCard} from '../PollManagement/Components/PollFreezeCard';

class ManageDialogView extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            show: props.open,
            animate: props.open
        };
        this.slideDuration = 300;
        this._timeout = null;
        this.handleKeyDown = this.handleKeyDown.bind(this);
    }

    componentDidMount() {
        document.addEventListener('keydown', this.handleKeyDown);
    }

    componentDidUpdate(prevProps) {
        if (prevProps.open !== this.props.open) {
            if (this.props.open) {
                this.setState({ show: true }, () => {
                    this._timeout = setTimeout(() => this.setState({ animate: true }), 10);
                });
            } else if (this.state.show) {
                this.setState({ animate: false });
                this._timeout = setTimeout(() => this.setState({ show: false }), this.slideDuration);
            }
        }
    }

    handleKeyDown(e) {
        if (e.key === 'Escape') {
            this.props.onClose();
        }
    }

    componentWillUnmount() {
        if (this._timeout) clearTimeout(this._timeout);
        document.removeEventListener('keydown', this.handleKeyDown);
    }

    render() {
        if (!this.state.show) return null;

        return (
            <Modal show={this.state.show} centered dialogClassName="manage-modal-dialog">
                <Modal.Header>
                    <Modal.Title className="modal-title">
                    Manage Judges &amp; Teams
                    </Modal.Title>
                    <button type="button" className="close-btn" onClick={this.props.onClose} aria-label="Close">
                        <i className="fas fa-times"></i>
                    </button>
                </Modal.Header>
                <Modal.Body>
                    <main className='main-body'>
                        <section className="users-management">
                            <div style={{ paddingBottom: '40px' }}>
                                <h3 className="section-header">Register New User</h3>
                                <RegisterUser />
                            </div>

                            <h3 className="section-header">Delete User</h3>
                            <DeleteUser></DeleteUser>
                        </section>
                        <section className="teams-management">
                            <h3 className="section-header">Register New Team</h3>
                            <ManageTeams></ManageTeams>
                        </section>
                        <section className="global-actions">
                            <h3 className="section-header">Delete All Answers</h3>
                            <ResetAnswers></ResetAnswers>
                            <div className="freeze-section">                                   
                                <PollFreezeCard/>
                            </div>                            
                        </section>
                    </main>
                </Modal.Body>
            </Modal>
        );
    }
}

export default ManageDialogView;
